<template>
	<b-container style="margin-top:57px;" v-if="allLoaded">
		<div class="row" v-if="score">
			<table class="table col-12 answerBox text-center">
				<thead>
					<tr>
						<th scope="col">Student Score</th>
						<th scope="col">Total Score</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td @click="changeStudentScore()" class="pressable">{{ score.studentScore }}</td>
						<td>{{ score.totalScore }}</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="row">
			<a :class="'col-12 col-sm-6 btn' + (saved ? ' btn-secondary' : ' btn-success')" @click="saveResult()">Save</a>
			<a @click="resetResult()" class="btn btn-warning col-12 col-sm-6">Reset</a>
		</div>
		<div class="row">
			<div :class="((i == 0) ? 'col-12' : 'col-12') + ' answerBox ' + ((chld.Results == null) ? 'dulledBox' : '')" v-for="(chld,i) in  adat" v-bind:key="i">
				<h5 class="col-12 text-center"><small>{{i}}. #{{ chld.ID }} [{{ (chld.Content.ContentType == "BOOK" || chld.Content.ContentType == "VIDEO") ? chld.Content.ContentType : chld.Content.Component }}]</small> {{ chld.Content.Title }} <small><strong>|| {{ resultarr[i].studentScore }} / {{ resultarr[i].totalScore }} ||</strong></small></h5>
				<hr class="col-8">
				<div class="col-12 text-center">
					<table class="table table-dark" v-if="i == 0">
						<thead>
							<tr>
								<th scope="col">Assigned On</th>
								<th scope="col">Due On</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>{{ chld.AssignedOn }}</td>
								<td>{{ chld.DueOn }}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<hr class="col-8" v-if="i == 0">
				<div class="col-12 text-center red-txt" v-if="resultarr[i].type == 'unanswered'">Unanswered</div>
				<div class="col-12 text-center red-txt" v-if="resultarr[i].type == 'null'">!</div>
				<div class="col-12 text-center" v-if="resultarr[i].type == 'seen'"><b>Seen on : {{ resultarr[i].seen }}</b></div>
				<div class="col-12 text-center" v-if="resultarr[i].type == 'vocab'">
					<table class="table table-dark">
						<thead>
							<tr>
								<th scope="col">Student Answer</th>
								<th scope="col">Correct Answer</th>
								<th scope="col">Scored</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(stans, j) in resultarr[i].studentAnswers" v-bind:key="'stans' + j">
								<td>{{stans}}</td>
								<td>{{ resultarr[i].correctAnswers[j].word }}</td>
								<td @click="toggleScore(i, j)" :class="((resultarr[i].studentScoreArr[j] == 0) ? 'red-txt' : 'green-txt') + ' pressable'">{{ (resultarr[i].studentScoreArr[j] == 0) ? 'Incorrect' : 'Correct' }}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="col-12 text-center" v-if="resultarr[i].type == 'book'">
					<table class="table table-dark col" v-for="(page, pn) in resultarr[i].correctAnswers" v-if="page">
						<caption class="text-center"> Page #{{pn+1}}</caption>
						<thead>
							<tr>
								<th scope="col">Student Answer</th>
								<th scope="col">Correct Answer</th>
								<th scope="col">Scored</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(cans, j) in page" v-bind:key="'bookstans' + j">
								<td>{{ resultarr[i].studentAnswers[pn][j] }}</td>
								<td>{{ cans }}</td>
								<td v-if="resultarr[i].studentScoreArr[pn]">
										<span v-if="resultarr[i].studentAnswers[pn][j] != null" @click="toggleScoreBook(i, pn, j)" :class="((resultarr[i].studentScoreArr[pn][j] == 0) ? 'red-txt' : 'green-txt') + ' pressable col-12'">{{ (resultarr[i].studentScoreArr[pn][j] == 0) ? 'Incorrect' : 'Correct' }}</span>
									<span v-else class="red-txt"><small>Unanswered</small></span>
								</td>
								<td v-else class="red-txt"><small>Unanswered</small></td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</b-container>
	<b-container style="margin-top:57px;" v-else>
		<div class="row">
			<span class="col-12 text-center answerBox">Loading...</span>
		</div>
	</b-container>
</template>

<script>
	//AssignmentID: {{assignmentId}}<br /> StudentID: {{studentId}}
import { ajaxGet,ajaxPost } from "../../ajax";
import Vue from 'vue';
  import {apiUrl} from "@/main";
export default {
    props: ["assignmentId", "studentId", "token"],
    data: function() {
        return {
        	allLoaded: false,
        	adat: undefined,
        	resultarr: undefined,
        	score: undefined,
        	saved: false
        };
    },
    mounted: function(){
    	ajaxGet(apiUrl() +"/assignments/"+this.assignmentId+"/results/"+this.studentId+"/full",
    	// ajaxGet("http://api.dex/answers.php",
        (dat) => {
        	var buff = [];
        	buff.push(dat.rootAssignment);
        	dat.children.forEach((c,i) => {
        		buff[i+1] = c;
        	});
        	var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        	buff.forEach(e => {
        		e.AssignedOn = new Date(Date.parse(e.AssignedOn)).toLocaleDateString("en-US", options);
        		e.DueOn = new Date(Date.parse(e.DueOn)).toLocaleDateString("en-US", options);
        	});
        	console.log("DATA:",[...buff]);
        	this.adat = buff;

        	this.calculateResults();
        },
        (err) =>{
        	console.log("ERROR:", err);
        }, localStorage.token);
    },
    methods: {
    	changeStudentScore: function(){
    		var s = prompt("Enter new score for the stUdent:", this.score.studentScore);
    		if(s){
    			this.score.studentScore = s;
    			this.$forceUpdate();
    		}
    	},
    	saveResult: function(){
    		if(this.saved) return null;
    		ajaxPost(apiUrl() +"/assignments/"+this.assignmentId+"/results/"+this.studentId+"/graded",
    		{
    			Answers: this.resultarr,
    			Score: this.score.studentScore.toString(),
    			MaxScore: this.score.totalScore.toString()
    		},
    		(dat) => {console.log("SAVED:", dat);},
    		(err) => {console.log("SAVE ERROR:", err)},
    		localStorage.token);
    		this.saved = true;
    	},
    	resetResult: function(){
    		this.calculateResults(false);
    		this.saved = false;
    		this.saveResult();
    	},
    	toggleScoreBook: function(i, pn, j){
    		var current = this.resultarr[i].studentScoreArr[j];
			if(this.resultarr[i].studentScoreArr[pn][j] == 0){
				this.resultarr[i].studentScoreArr[pn][j] = 1;
				this.resultarr[i].studentScore += 1;
				this.score.studentScore += 1;
			}else{
				this.resultarr[i].studentScoreArr[pn][j] = 0;
				this.resultarr[i].studentScore -= 1;
				this.score.studentScore -= 1;
			}
			this.saved = false;
			this.$forceUpdate();
    	},
    	toggleScore: function(i, j){
    		var current = this.resultarr[i].studentScoreArr[j];
			if(this.resultarr[i].studentScoreArr[j] == 0){
				this.resultarr[i].studentScoreArr[j] = 1;
				this.resultarr[i].studentScore += 1;
				this.score.studentScore += 1;
			}else{
				this.resultarr[i].studentScoreArr[j] = 0;
				this.resultarr[i].studentScore -= 1;
				this.score.studentScore -= 1;
			}
			this.saved = false;
			this.$forceUpdate();
    	},
    	loadFromDB: function(){
    		/*
				GET /assignments/:assignmentId/results/:studentId/graded
				Returns:
				{
				"Score" : "0",
				"MaxScore: "0",
				"Answers" :[true,false,...]
				}

				POST /assignments/:assignmentId/results/:studentId/graded
				Request body:
				{
				"Score" : "0",
				"MaxScore: "0",
				"Answers" :[true,false,...]
				}
			*/
    		ajaxGet(apiUrl() +"/assignments/"+this.assignmentId+"/results/"+this.studentId+"/graded",
    			(dat) => {
    				console.log("DATA LOADED", dat);
    				if(dat.length == 0){
    					this.saved = false;
    				}else{
    					this.resultarr = JSON.parse(dat.Answers.S);
    					this.score.studentScore = parseInt(dat.Score.S);
    					this.score.totalScore = parseInt(dat.MaxScore.S);
    					this.saved = true;
    				}
    				this.allLoaded = true;
    			},
    			(err) => {console.log("ERROR", err)},
    			localStorage.token);
    	},
    	calculateResults: function(getFromDb = true){
    		this.resultarr = [];
    		this.score = {
    			totalScore: 0,
    			studentScore: 0
    		};

    		this.adat.forEach((ass, i) => {
    			var flag = (ass.Content.Component != null) ? ass.Content.Component.toLowerCase() : ass.Content.ContentType.toLowerCase();
        		var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    			// console.log(i, flag);
    			switch(flag){
    				case "book":
    					if(ass.Results){
    						var totalBlanks = 0;
    						var totalScoreOfStudent = 0;
    						var correctAnswers = [];
    						var studentAnswers = [];
    						var studentScoreArr = [];
    						ass.Content.Data.blanks.forEach((blankPage, x) => {
    							if(x >= ass.StartPoint && x <= ass.EndPoint){
    								totalBlanks += blankPage.length;
    								blankPage.forEach((blank, y) => {
    									if(!correctAnswers[x]) correctAnswers[x] = [];
    									if(!studentAnswers[x]) studentAnswers[x] = [];
    									correctAnswers[x][y] = blank;
    									studentAnswers[x][y] = (ass.Results[x]) ? ((ass.Results[x][y]) ? ((ass.Results[x][y].trim() != "") ? ass.Results[x][y] : null) : null) : null;
    								});
    							}
    						});
    						ass.Results.forEach((sbp,x) => {
    							if(sbp != null)
    							sbp.forEach((sb, y) => {
    								if(sb == ass.Content.Data.blanks[x][y] && x >= ass.StartPoint && x <= ass.EndPoint){
    									totalScoreOfStudent += 1;
    									if(!studentScoreArr[x]) studentScoreArr[x] = [];
    									studentScoreArr[x][y] = 1;
    								}else{
    									if(!studentScoreArr[x]) studentScoreArr[x] = [];
    									studentScoreArr[x][y] = 0;
    								}
    							});
    						});
    						this.resultarr[i] = {
    							type: 'book',
    							flag: flag,
    							studentAnswers: studentAnswers,
    							correctAnswers: correctAnswers,
    							totalScore: totalBlanks,
								studentScoreArr: studentScoreArr,
    							studentScore: totalScoreOfStudent
    						}
    						this.score.totalScore += totalBlanks;
    						this.score.studentScore += totalScoreOfStudent;
    					}else{
    						var totalBlanks = 0;
    						ass.Content.Data.blanks.forEach((blankPage) => {
    							totalBlanks += blankPage.length;
    						});
    						this.resultarr[i] = {
    							type: 'unanswered',
    							flag: flag,
    							totalScore: totalBlanks,
    							studentScore: 0
    						}
    						this.score.totalScore += totalBlanks;
    					}
    					break;
    				case "vocab":
    					if(ass.Results){
    						this.resultarr[i] = {
	    						type: 'vocab',
	    						flag: flag,
	    						studentAnswers: ass.Results,
	    						correctAnswers: ass.Content.Data.vocab,
								totalScore: ass.Content.Data.vocab.length,
								studentScoreArr: [],
								studentScore: 0
	    					};
	    					this.score.totalScore += ass.Content.Data.vocab.length;
	    					ass.Results.forEach((res,x) => {
		    					if(res == ass.Content.Data.vocab[x].word){
		    						this.score.studentScore += 1;
		    						this.resultarr[i].studentScoreArr[x] = 1;
		    						this.resultarr[i].studentScore += 1;
		    					}else{
		    						this.resultarr[i].studentScoreArr[x] = 0;
		    					}
	    					});
    					}else{
    						this.resultarr[i] = {
    							type: 'unanswered',
    							flag: flag,
    							totalScore: ass.Content.Data.vocab.length,
    							studentScore: 0
    						}
    						this.score.totalScore += ass.Content.Data.vocab.length;
    					}
    					break;
    				case "video":
    					if(ass.Results){
    						if(ass.Results.last_viewed_on){
    							this.resultarr[i] = {
	    							type: 'seen',
	    							seen: new Date((ass.Results.last_viewed_on)).toLocaleDateString("en-US", options),
	    							flag: flag,
	    							totalScore: 1,
	    							studentScore: 1
	    						};
	    						this.score.totalScore += 1;
	    						this.score.studentScore += 1;
    						}else{
    							this.resultarr[i] = {
	    							type: 'null',
	    							flag: flag,
	    							totalScore: 1,
	    							studentScore: 1
	    						}
    						}
    					}else{
    						this.resultarr[i] = {
    							type: 'unanswered',
    							flag: flag,
    							totalScore: 1,
    							studentScore: 0
    						}
    						this.score.totalScore += 1;
    					}
    					break;
    				default:
    					if(ass.Results){
    						if(ass.Results.seen){
    							this.resultarr[i] = {
	    							type: 'seen',
	    							seen: new Date((ass.Results.seen)).toLocaleDateString("en-US", options),
	    							flag: flag,
	    							totalScore: 1,
	    							studentScore: 1
	    						};
	    						this.score.totalScore += 1;
	    						this.score.studentScore += 1;
    						}else{
    							this.resultarr[i] = {
	    							type: 'null',
	    							flag: flag,
	    							totalScore: 1,
	    							studentScore: 1
	    						}
    						}
    					}else{
    						this.resultarr[i] = {
    							type: 'unanswered',
    							flag: flag,
    							totalScore: 1,
    							studentScore: 0
    						}
    						this.score.totalScore += 1;
    					}
    					break;
    			}
    		});

    		console.log(this.resultarr);
    		console.log("TOTAL SCORE:", this.score);
    		if(getFromDb)
    		this.loadFromDB();
    	}
    }
}
</script>

<style scoped>
	.answerBox{
		background: white;
		margin-bottom: 2em;
		color: #121212 !important;
		border: 2px solid black;
		box-sizing: border-box;
	}
	.answerBox h5 small{
		text-transform: uppercase;
	}
	.answerBox hr{
		border-bottom: 2px solid black;
	}
	.red-txt{
		color: red !important;
		font-weight: bold;
	}
	.red-txt small{
		font-weight: thin;
	}
	.green-txt{
		color: green !important;
		font-weight: bold;
	}
	.dulledBox{
		background: #232323;
		color: #efefef !important;
	}
	.pressable{
		cursor: pointer;
		transition: all 0.5s ease-in;
	}
	.pressable:hover{
		background: #434343;
		color: #efefef;
	}
	.save-icon{
		position: fixed;
		right: -100px;
		top: 80px;
		width: 100px;
		height: 100px;
		background: white;
		transition: all 0.5s ease-in;
		border-radius: 5px;
		cursor: pointer;
	}
	.save-icon:hover{
		background: #121212;
	}
	.save-icon svg{
		width: 100%;
		height: 100%;
		fill: green;
		transition: all 0.5s ease-in;
	}
	.save-icon:hover svg{
		width: 100%;
		height: 100%;
		fill: #55ff55;
	}
	.save-icon-shown{
		right: 0px !important;
	}
</style>